export enum TagTaskActionType {
    DAY = 0,
    PLANNED = 1,
    COMPLETE = 2,
    DELETE = 3
}